import { render, staticRenderFns } from "./Individual.vue?vue&type=template&id=59c9ee0c&scoped=true"
import script from "./Individual.vue?vue&type=script&lang=js"
export * from "./Individual.vue?vue&type=script&lang=js"
import style0 from "./Individual.vue?vue&type=style&index=0&id=59c9ee0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c9ee0c",
  null
  
)

export default component.exports